import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_GlobalConstants} from '../../../services/globalConstants.service';
import {_UsersService} from "../../../services/users.service";
import {Observable} from "rxjs/Observable";
import {_ReferenceDataService} from "../../../services/referenceData.service";

declare var jQuery: any;
declare var $: any;
declare var defaultGridViewSettings;
declare var globalConstants;

@Component({
  selector: 'asset-trades-h',
  templateUrl: './asset-trades-h.component.html',
  styleUrls: ['./asset-trades-h.component.css'],
})

export class AssetTradesHistory implements OnInit, OnDestroy {

  private subscription: any;
  private users: any;
  private accounts: any;

  constructor(private titleService: Title, private constants: _GlobalConstants, private userService: _UsersService, private referenceData: _ReferenceDataService) {
  }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Asset Trade Event Log");

    this.subscription = Observable.forkJoin(this.userService.getUsers(), this.referenceData.getAccounts()).subscribe((res: Array<any>) => {
      this.users = res[0];
      this.accounts = res[1];
      this.ready();
    });
  }

  ready() {
    var accounts = this.accounts;
    var users = this.users;

    // Asset Trade Events.
    var initrowdetails = function (index, parentElement, gridElement, datarecord) {

      // Allocations
      var sourceAllocations = {
        localdata: datarecord.allocations,
        datatype: "json",
        datafields: [{
          name: 'accountId',
          type: 'string'
        }, {
          name: 'accountDisplayName',
          type: 'string',
          value: 'accountId',
          values: {
            source: accounts,
            value: 'accountId',
            name: 'displayName'
          }
        }, {
          name: 'quantity',
          type: 'string'
        }, {
          name: 'commission',
          type: 'string'
        }, {
          name: 'fees',
          type: 'string'
        }]
      };
      var settingsAllocations = defaultGridViewSettings("#jqxGridAllocations", sourceAllocations);
      settingsAllocations.width = '97%';
      settingsAllocations.height = '99%';
      settingsAllocations.columns = [{
        text: 'Account',
        columntype: 'textbox',
        datafield: 'accountDisplayName',
        width: '15%'
      }, {
        text: 'Quantity',
        columntype: 'textbox',
        datafield: 'quantity',
        width: '20%'
      }, {
        text: 'Commission',
        columntype: 'textbox',
        datafield: 'commission',
        width: '20%'
      }, {
        text: 'Fees',
        columntype: 'textbox',
        datafield: 'fees',
        width: '20%'
      }];

      var gridDiv = $($(parentElement).children()[0]);
      $(gridDiv).jqxGrid(settingsAllocations);
    }

    // initialize jqxGrid
    var source = {
      datatype: "json",
      datafields: [{
        name: 'eventId',
        type: 'string'
      }, {
        name: 'eventTimestamp',
        type: 'date',
        format: 'yyyy-MM-dd HH:mm:ss.fff'
      }, {
        name: 'eventUserId',
        type: 'string'
      }, {
        name: 'eventUserDisplayName',
        type: 'string',
        value: 'eventUserId',
        values: {
          source: users,
          value: 'userId',
          name: 'displayName'
        }
      }, {
        name: 'eventIpAddress',
        type: 'string'
      }, {
        name: 'eventAction',
        type: 'string'
      }, {
        name: 'eventActionDisplayName',
        type: 'string',
        value: 'eventAction',
        values: {
          source: this.constants.getTranslatedValues('resources.assetPositionEvent.action'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'externalTradeId',
        type: 'string'
      }, {
        name: 'updateTimestamp',
        type: 'date',
        format: 'yyyy-MM-dd HH:mm:ss.fff'
      }, {
        name: 'externalSecurityId',
        type: 'string'
      }, {
        name: 'positionAction',
        type: 'string'
      }, {
        name: 'actionDisplayName',
        type: 'string',
        value: 'positionAction',
        values: {
          source: this.constants.getTranslatedValues('common.staticValues.positionAction'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'quantity',
        type: 'string'
      }, {
        name: 'price',
        type: 'string'
      }, {
        name: 'commission',
        type: 'string'
      }, {
        name: 'fees',
        type: 'string'
      }, {
        name: 'currency',
        type: 'string'
      }, {
        name: 'allocations',
        type: 'array'
      }],
      id: 'eventID',
      url: '/ajax/asset-positions/events',
      type: 'GET',
      async: true
    };
    var settings = defaultGridViewSettings("#jqxGrid", source);
    settings.columns = [{
      text: 'Timestamp',
      columntype: 'datetimeinput',
      datafield: 'eventTimestamp',
      cellsformat: 'MM/dd/yyyy HH:mm:ss.fff',
      width: '160'
    }, {
      text: 'User',
      columntype: 'textbox',
      datafield: 'eventUserDisplayName',
      width: '110'
    }, {
      text: 'IP Address',
      columntype: 'textbox',
      datafield: 'eventIpAddress',
      width: '80'
    }, {
      text: 'Action',
      columntype: 'textbox',
      datafield: 'eventActionDisplayName',
      width: '100'
    }, {
      text: 'External Trade ID',
      columntype: 'textbox',
      datafield: 'externalTradeId',
      width: '130'
    }, {
      text: 'Trade Timestamp',
      columntype: 'datetimeinput',
      cellsformat: 'MM/dd/yyyy HH:mm:ss.fff',
      datafield: 'updateTimestamp',
      width: '160'
    }, {
      text: 'External Security ID',
      columntype: 'textbox',
      datafield: 'externalSecurityId',
      width: '130'
    }, {
      text: 'Trade Action',
      columntype: 'textbox',
      datafield: 'actionDisplayName',
      width: '100'
    }, {
      text: 'Quantity',
      columntype: 'textbox',
      datafield: 'quantity',
      width: '100'
    }, {
      text: 'Price',
      columntype: 'textbox',
      datafield: 'price',
      width: '100'
    }, {
      text: 'Commission',
      columntype: 'textbox',
      datafield: 'commission',
      width: '100'
    }, {
      text: 'Fees',
      columntype: 'textbox',
      datafield: 'fees',
      width: '100'
    }, {
      text: 'Ccy',
      columntype: 'textbox',
      datafield: 'currency',
      width: '50'
    }];
    settings.rowdetails = true;
    settings.initrowdetails = initrowdetails;
    settings.rowdetailstemplate = {
      rowdetails: "<div id='jqxGridAllocations' style='overflow: hidden;'></div>",
      rowdetailsheight: 300,
      rowdetailshidden: true
    };

    $("#jqxGrid").jqxGrid(settings);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/asset-trades-h/asset-trades-h.component.ts